import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b9cf4a1")

_pushScopeId("data-v-4b9cf4a1")
const _hoisted_1 = {
  key: 0,
  class: "flex items-center mr-8"
}
const _hoisted_2 = { class: "mr-2 font-size-14" }
const _hoisted_3 = { class: "sys-paging" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-double-left font-size-24" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "flex"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-chevron-double-right font-size-24" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MorePaging = _resolveComponent("MorePaging")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showItemPerPage)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('displayedResults')), 1),
          _createVNode(_component_Dropdown, {
            height: '32px',
            class: "w-18 font-size-14",
            "options-select": [20, 50, 100, 200],
            modelValue: _ctx.itemPerPagesValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.itemPerPagesValue = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "cell-page cursor-pointer",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.choosePage(1)))
      }, [
        _hoisted_4
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.totalPage, (page) => {
        return (_openBlock(), _createBlock("div", {
          key: page,
          class: { active: page === _ctx.pageActive }
        }, [
          (page == 1 || page == _ctx.totalPage)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: [page === _ctx.pageActive ? 'cursor-default' : 'cursor-pointer', "cell-page"],
                onClick: ($event: any) => (_ctx.choosePage(page))
              }, _toDisplayString(page), 11, ["onClick"]))
            : (_openBlock(), _createBlock("div", _hoisted_5, [
                (_ctx.showMoreIncrease(page))
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "cell-page cursor-pointer",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.choosePage(_ctx.pageActive + 1)))
                    }, [
                      _createVNode(_component_MorePaging)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showMoreDecrease(page))
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: "cell-page cursor-pointer",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.choosePage(_ctx.pageActive - 1)))
                    }, [
                      _createVNode(_component_MorePaging)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pageActive - 2 < page && page < _ctx.pageActive + 2)
                  ? (_openBlock(), _createBlock("div", {
                      key: 2,
                      class: ["cell-page", page === _ctx.pageActive ? 'cursor-default' : 'cursor-pointer'],
                      onClick: ($event: any) => (_ctx.choosePage(page))
                    }, _toDisplayString(page), 11, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.pageActive == 1 && page == 3)
                  ? (_openBlock(), _createBlock("div", {
                      key: 3,
                      class: ["cell-page", page === _ctx.pageActive ? 'cursor-default' : 'cursor-pointer'],
                      onClick: ($event: any) => (_ctx.choosePage(page))
                    }, _toDisplayString(page), 11, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.pageActive == _ctx.totalPage && page == _ctx.totalPage - 2)
                  ? (_openBlock(), _createBlock("div", {
                      key: 4,
                      class: ["cell-page", page === _ctx.pageActive ? 'cursor-default' : 'cursor-pointer'],
                      onClick: ($event: any) => (_ctx.choosePage(page))
                    }, _toDisplayString(page), 11, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
        ], 2))
      }), 128)),
      _createVNode("div", {
        class: "cell-page cursor-pointer",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.choosePage(_ctx.totalPage)))
      }, [
        _hoisted_6
      ])
    ])
  ], 64))
})